import { render, staticRenderFns } from "./Other.vue?vue&type=template&id=4e5d7a4d&scoped=true"
import script from "./Other.vue?vue&type=script&lang=ts"
export * from "./Other.vue?vue&type=script&lang=ts"
import style0 from "./Other.vue?vue&type=style&index=0&id=4e5d7a4d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e5d7a4d",
  null
  
)

export default component.exports